import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatPaginator, MatTableDataSource } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RelatorioService } from 'app/service/cliente/relatorio.service';
import { PermissionsService } from 'app/service/permission/permissions.service';

@Component({
  selector: 'app-user-perm-group-dialog',
  templateUrl: './user-perm-group-dialog.component.html',
  styleUrls: ['./user-perm-group-dialog.component.scss'],
})
export class UserPermGroupDialogComponent implements OnInit {
  @ViewChild('usersPaginator') usersPaginator: MatPaginator;
  @ViewChild('authsPaginator') authsPaginator: MatPaginator;
  dataSourceUsers = new MatTableDataSource<any>([]);
  dataSourceUsersAuth = new MatTableDataSource<any>([]);
  usersAuthToSave: any[] = [];

  displayedColumns = ['name', 'action'];

  isNewChange = false;

  isLoading = true;

  constructor(
    public dialogRef: MatDialogRef<UserPermGroupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private relatorioService: RelatorioService,
    public _snackBar: MatSnackBar,
    private permissionsService: PermissionsService
  ) {
    this.dialogRef.beforeClose().subscribe((e) => {
      this.dialogRef.close(this.isNewChange);
    });
  }

  ngOnInit() {
    this.getUsuarios();
  }

  ngAfterViewInit() {
    this.dataSourceUsers.paginator = this.usersPaginator;
    this.dataSourceUsersAuth.paginator = this.authsPaginator;
  }

  getUsuarios() {
    this.relatorioService.getUsuariosPorCliente(this.data.client.id).subscribe(
      (data) => {
        this.dataSourceUsers.data = data.map((el) => ({
          id: el.id,
          nome: el.nome,
        }));

        this.getUsersAuthByGroup();
      },
      (err) => {
        console.error(err);
        this.openSnackBar(
          'Erro ao buscar Usuários, tente novamente mais tarde',
          true
        );
        this.isLoading = false;
        this.dialogRef.close();
        return;
      }
    );
  }

  getUsersAuthByGroup() {
    this.permissionsService
      .getUsersByClientPermissionGroup(this.data.client.id, this.data.group.id)
      .subscribe(
        (users) => {
          if (users.length === 0) {
            this.openSnackBar('Nenhum usuário autorizado neste Grupo', true);
          } else {
            users.forEach((e) => {
              this.setUserAuth(e);
            });
          }
          this.isLoading = false;
        },
        (err) => {
          this.isLoading = false;
          this.openSnackBar(
            'Ocorreu um erro ao buscar usuários autorizados',
            true
          );
          console.error(err);
          this.dialogRef.close();
        }
      );
  }

  applyFilter(val: string) {
    val = val.trim();
    val = val.toLowerCase();
    this.dataSourceUsers.filter = val;
  }

  applyFilterAuth(val: string) {
    val = val.trim();
    val = val.toLowerCase();
    this.dataSourceUsersAuth.filter = val;
  }

  setUserAuth(user) {
    let i = this.dataSourceUsers.data.findIndex((e) => e.id === user.id);
    this.dataSourceUsers.data.splice(i, 1);
    this.dataSourceUsers.data = this.dataSourceUsers.data;

    this.dataSourceUsersAuth.data.push(user);
    this.dataSourceUsersAuth.data = this.dataSourceUsersAuth.data;
  }

  setUsersAuthAll() {
    this.dataSourceUsersAuth.data = this.dataSourceUsersAuth.data.concat(
      this.dataSourceUsers.filteredData
    );
    this.dataSourceUsers.data = this.dataSourceUsers.data.filter(
      (e) => !this.dataSourceUsers.filteredData.includes(e)
    );
  }

  removeUsersAuthAll() {
    this.dataSourceUsers.data = this.dataSourceUsers.data.concat(
      this.dataSourceUsersAuth.filteredData
    );
    this.dataSourceUsersAuth.data = this.dataSourceUsersAuth.data.filter(
      (e) => !this.dataSourceUsersAuth.filteredData.includes(e)
    );
  }

  removeUserAuth(user) {
    let i = this.dataSourceUsersAuth.data.findIndex((e) => e.id === user.id);
    this.dataSourceUsersAuth.data.splice(i, 1);
    this.dataSourceUsersAuth.data = this.dataSourceUsersAuth.data;

    this.dataSourceUsers.data.push(user);
    this.dataSourceUsers.data = this.dataSourceUsers.data;
  }

  saveChanges() {
    this.usersAuthToSave = [];
    this.isLoading = true;
    this.dataSourceUsersAuth.data.forEach((u) => {
      const userAuth = {
        clienteId: this.data.client.id,
        roleId: this.data.group.id,
        usuarioId: u.id,
      };
      this.usersAuthToSave.push(userAuth);
    });

    this.permissionsService
      .saveUsersToGroup(
        this.usersAuthToSave,
        this.data.client.id,
        this.data.group.id
      )
      .subscribe(
        () => {
          this.isLoading = false;
          this.openSnackBar('Alterações salvas com sucesso!', false);
          this.isNewChange = true;
        },
        (err) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar(
            'Ocorreu um erro ao salvar as alterações, tente novamente em instantes',
            true
          );
        }
      );
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, '', {
      horizontalPosition: 'right',
      verticalPosition: 'top',
      duration: 3000,
      panelClass: isErr ? ['error-snackbar'] : ['success-snackbar'],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/dialog/user-perm-group-dialog/user-perm-group-dialog.component.ts